export default {
	"ability": {
		"warning": "การแจ้งเตือนล่วงหน้า",
		"checkTime": "ยืนยันคำสั่งล่วงหน้า (ชั่วโมง)",
		"pickupTime": "เวลาแจ้งเตือนการจัดส่งล่าช้า (ชั่วโมง)",
		"backTime": "เวลารับ (วัน)",
		"schedulingTime": "เวลาจัดกำหนดการล่วงหน้า (ชั่วโมง)",
		"deliveryTime": "การแจ้งเตือนการจัดส่งล่าช้า (ชั่วโมง)",
		"continuous": "ต่อเนื่อง",
		"tips1": "การแจ้งเตือนอุณหภูมิจะแจ้งให้ผู้บังคับบัญชาทราบทันที",
		"gpsOutPush": "ความถี่ในการส่งข้อมูลจีพีเอส (นาที)",
		"customerExceptionTime": "ความทันต่อเวลาของความคิดเห็นของลูกค้า (วัน)",
		"transportTips": "การเข้าถึงคำสั่งจัดส่งสินค้า",
		"lightRate": "อัตราส่วนปริมาตร/น้ำหนัก",
		"orderMerge": "SKU ที่มีรายละเอียดเอกสารเหมือนกันจะถูกรวมโดยอัตโนมัติหรือไม่",
		"singleTrial": "ยืนยัน",
		"manualOrImportOrder": "สามารถปิดคำสั่งที่สร้างและนำเข้าด้วยตนเอง",
		"interfaceOrder": "อนุญาตให้ปิดคำสั่งจากระบบอื่นพร้อมด้วยอินเทอร์เฟสหรือไม่",
		"optionOrderStatus": "อนุญาตให้ดำเนินการเพิกถอนการยืนยัน",
		"notScheduling": "ไม่ได้กำหนดไว้",
		"notPickUp": "ไม่ได้รับ",
		"orderMustProject": "ค่าธรรมเนียม/ส่วนลดจำเป็นต้องกรอก ตอนสร้างใบคำสั่งขนส่งสินค้า",
		"pushOrderAutoMatch": "จับคู่สถานที่โดยอัตโนมัติขณะรับคำสั่งด้วยอินเทอร์เฟส",
		"billingTips": "การเรียกเก็บเงิน",
		"billingPoint": "คำสั่งจัดส่งจะกำหนดจุดธุรกิจสำหรับการเรียกเก็บเงิน",
		"none": "ไม่มีการควบคุม",
		"dispatched": "กำหนดการ",
		"routeBusinessBillingPoint": "จุดบริการเรียกเก็บเงินจะถูกสร้างขึ้นในคำสั่งจัดส่ง",
		"billingLogDebug": "บันทึกการเรียกเก็บเงินอย่างละเอียด",
		"planTips": "วางแผน",
		"routeTempComposeRule": "สร้างรายการคำสั่งจัดส่งที่มีความแตกต่างของอุณหภูมิ",
		"confirmGrouporder": "สร้างคำสั่งจัดส่งจากเอกสารออนไลน์โดยอัตโนมัติ",
		"ms": "หลายงาน +  งานเดียว",
		"m": "การทำงานหลายอย่างพร้อมกัน",
		"routeTimeComposeRule": "เวลาในการจัดส่งทับซ้อนกัน",
		"mixFullLoadRatio": "ค่าขีดจำกัดต่ำสุดของการบรรทุกเต็มคันรถ",
		"maxFullLoadRatio": "ค่าขีดจำกัดสูงสุดของการบรรทุกเต็มคันรถ",
		"subsequentProcessing": "การดำเนินการอัตโนมัติในภายหลังของคำสั่งสำหรับยานพาหนะในระหว่างการตรวจสอบคำสั่ง",
		"n": "ไม่ต้องจัดการ",
		"c": "สร้างรายการจัดส่ง",
		"cc": "สร้างรายการจัดส่งและยืนยัน",
		"autoPlanSenderAddress": "รวมเส้นทางการจัดส่งที่อยู่ในกรอบการดำเนินงาน",
		"trialStrategy": "กลยุทธ์การทดลองวางแผนเส้นทาง",
		"scheduling": "จัดตารางวันเดียวกัน",
		"pScheduleRouteMustProject": "การจัดกำหนดการต้องมีสินค้า/รายการต่างๆ",
		"pDispatchVehicleReminder": "การแจ้งเตือนในการจัดตารางการใช้ยานพหนะซ้ำ",
		"departure": "วันออกเดินทางเดียวกัน",
		"pDispatchingOfflineCarrierCapacity": "จัดกำหนดการสำหรับข้อมูลขีดความสามารถของผู้ขนส่งแบบออฟไลน์",
		"mb": "ต้อง",
		"dmb": "ไม่จำเป็น",
		"pUnscheduledDocumentSwitch": "อนุญาตให้ผู้ขนส่งดูเอกสารที่ไม่ได้กำหนดไว้",
		"perform": "การดำเนินการ",
		"pContinueShortMessageOnOnlineuser": "ส่งข้อความต่อไปหลังจากส่งข้อความภายในพื้นที่",
		"pGpsMonitorNode": "จีพีเอสติดตามยานพาหนะ",
		"pTerminalShowExpFeedbackCsh": "แสดงหมายเลขติดต่อที่ผิดปกติ",
		"pTerminalShowCsh": "โทรศัพท์มือถือแสดงหมายเลขโทรศัพท์สำหรับการบริการลูกค้า",
		"pTerminalShowCshTel": "สายด่วนผู้บริโภค",
		"pAppointment": "จอง",
		"prebookPickupCapacityRequired": "ต้องระบุข้อมูลขีดความสามารถเมื่อทำการนัดหมายการรับสินค้า",
		"prebookDeliveryCapacityRequired": "ต้องระบุข้อมูลขีดความสามารถเมื่อทำการนัดหมายการส่งมอบ",
		"mustPrebook": "เอกสารที่สามารถจองกับระบบอื่นต้องถูกจอง",
		"pMustDeliverByOtherSystem": "เอกสารที่จองไว้กับระบบอื่นต้องถูกจัดส่งโดยระบบอื่น",
		"pPushCapacityToUp": "ขีดความสามารถถูกซิงโครไนซ์อย่างสมบูรณ์กับอัปสตรีม",
		"pNeedMsgForReserve": "ต้องส่งข้อความขณะจอง",
		"sendPickTips3": "รับ&ส่งสินค้า",
		"pPickupInforNeededTakePhoto": "ต้องอัพโหลดรูปการรับสินค้าเมื่อยืนยันการรับสินค้า",
		"pDeliveryInforNeededTakePhoto": "ต้องอัพโหลด POD เมื่อยืนยันการจัดส่ง",
		"pNeedConfirmDelivery": "การจัดส่ง ณ สถานที่ปลายทางต้องได้รับการยืนยัน",
		"pInterfaceSyncTransDataOp": "อินเทอร์เฟสการจัดส่งแบบซิงโครนัส - วิธีซิงโครไนซ์ข้อมูล -  [เลือก] ซิงโครไนซ์ข้อมูลและอัพเดตการรับสินค้า  [ยกเลิกการเลือก] ซิงโครไนซ์ข้อมูลเท่านั้น",
		"pDeliverySignAddressExceptionReason": "การจัดส่งนอกขอบเขตต้องกรอกเหตุผล",
		"pH5PickupDataEditableOnApiSync": "หลังจากซิงโครไนซ์ข้อมูลการจัดส่งจากระบบอัปสตรีม สนับสนุนให้พนักงานขับรถเปลี่ยนปริมาณการรับสินค้า",
		"pH5WorkingCollectMode1": "คำสั่งพร้อมรายการอย่างละเอียดตาม...",
		"pH5WorkingCollectMode2": "ความผิดปกติในการรับและส่งสินค้า",
		"wechatAndWeb": "มินิโปรแกรม/บัญชีสาธารณะ",
		"pScanPickupUploadPic": "การเก็บรวบรวมข้อมูลการรับสินค้าสำหรับบัญชีสาธารณะต้องมีรูปถ่าย",
		"pScanDeliveryUploadPic": "การเก็บรวบรวมข้อมูลการจัดส่งสำหรับบัญชีสาธารณะต้องมีรูปถ่าย",
		"pScanPickupDeliveryConfirm": "ข้อมูลที่รวบรวมโดยบัญชีสาธารณะต้องได้รับการยืนยัน",
		"pH5PickupCapacityEditable": "ข้อมูลยานพาหนะสามารถเปลี่ยนแปลงได้เมื่อมีบัญชีสาธารณะสำหรับการรับสินค้า",
		"pScanPickupedVehicleTemperature": "อุณหภูมิรถต้องถูกทดสอบสำหรับบัญชีสาธารณะเพื่อการรับสินค้า",
		"pScanPickupedGoodsTemperature": "อุณหภูมิของสินค้าต้องถูกทดสอบสำหรับบัญชีสาธารณะเพื่อการรับสินค้า",
		"pScanReceivedGoodsTemperature": "บัญชีสาธารณะต้องทดสอบอุณหภูมิของสินค้าขณะรับสินค้า",
		"pBetweenReceivedAndSignedRate": "ช่วงเวลาการรวบรวมและการอนุมัติที่เร็วที่สุด",
		"pPickupWaitDedaultTime": "ระยะเวลารอขนส่งเริ่มต้น (นาที)",
		"pTransferPrintMaxNumber": "ขีดจำกัดจำนวนการพิมพ์ใบขนส่งสินค้า",
		"pAutoDeliveryBuffer": "เผื่อเวลาอัตโนมัติ (ชั่วโมง) สำหรับการเสร็จสิ้นการส่งมอบ",
		"monitortips": "ควบคุม",
		"pDetentionGpsTimes": "ระยะพิกัดจุดตั้งต้น",
		"pVehicleStayTimeMax": "การจัดส่งผิดปกติ",
		"abilityTipsCarrier": "ต้องมีใบเสนอราคา สำหรับผู้รับจ้างบริการ",
		"upStreamOrder": "ผู้ส่งสินค้าต้นทางดำเนินการผลักดันคำสั่ง",
		"restingTime": "เวลาพัก",
		"minWorkingHourAlert": "แจ้งเตือนเวลาพัก (นาที)",
		"maxWorkingHourAlert": "เตือนก่อนแจ้งเตือนเวลาพัก (นาที)",
		"alertForOverWorkHour": "เตือนหลังแจ้งเตือนเวลาพัก (นาที)",
		"minRestingTimeDuration": "ระยะเวลาพักขั้นต่ำ (นาที)",
		"maxRestingTimeDuration": "ระยะเวลาพักสูงสุด (นาที)",
		"alertBeforeEndingMaxRestingTime": "เตือนก่อนหมดเวลาพัก (นาที)",
		"distanceOfNearbyRestStop": "ระยะแสดงผลจุดพักรถใกล้เคียง (กิโลเมตร)",
		"invalidMinWorkingHourAlert": "แจ้งเตือนเวลาพัก กรอกไม่ถูกต้อง",
		"invalidMaxWorkingHourAlert": "เตือนก่อนแจ้งเตือนเวลาพัก กรอกไม่ถูกต้อง",
		"invalidAlertForOverWorkHour": "เตือนหลังแจ้งเตือนเวลาพัก กรอกไม่ถูกต้อง",
		"invalidMinRestingTimeDuration": "ระยะเวลาพักขั้นต่ำ กรอกไม่ถูกต้อง",
		"invalidMaxRestingTimeDuration": "ระยะเวลาพักสูงสุด กรอกไม่ถูกต้อง",
		"invalidAlertBeforeEndingMaxRestingTime": "เตือนก่อนหมดเวลาพัก กรอกไม่ถูกต้อง",
		"invalidDistanceOfNearbyRestStop": "ระยะแสดงผลจุดพักรถใกล้เคียง กรอกไม่ถูกต้อง",
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/ability/ability.js